import React, { useState } from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import { FormLabel } from "@mui/material";
import { FormHidden } from "../../../../../../components/Forms/FormHidden";
import { ScrubbableNumber } from "../../../../../../components/Forms/ScrubbableNumber";
import { useWatch } from "react-hook-form";

function Translate({ name, required }: JSInputProps) {
  const initialValue = useWatch({ name });
  const [string_x, string_y] = (initialValue ?? "0 0").split(" ");
  const num_x = Number.parseFloat(string_x);
  const num_y = Number.parseFloat(string_y);
  const initial_x = Number.isFinite(num_x) ? num_x : 0;
  const initial_y = Number.isFinite(num_y) ? num_y : 0;
  const [x, sx] = useState<number>(initial_x);
  const [y, sy] = useState<number>(initial_y);

  const value = x === 0 && y === 0 ? undefined : `${x}px ${y}px`;

  return (
    <>
      <FormHidden name={name} value={value} />
      <div
        style={{
          display: "grid",
          gap: "8px",
          gridTemplateColumns: "max-content 1fr",
          marginLeft: "16px",
          alignItems: "center",
        }}
      >
        <FormLabel>Horizontal</FormLabel>
        <ScrubbableNumber
          defaultValue={initial_x}
          onBlur={(x) => sx(x)}
          onChange={(x) => (Number.isFinite(x) ? sx(x) : null)}
          onScrub={(dx) => sx((x) => dx + x)}
        />
        <FormLabel>Vertical</FormLabel>
        <ScrubbableNumber
          defaultValue={initial_y}
          onBlur={(y) => sy(y)}
          onChange={(y) => (Number.isFinite(y) ? sy(y) : null)}
          onScrub={(dy) => sy((y) => dy + y)}
        />
      </div>
    </>
  );
}

export const JSTranslateComponent: JSInputComponent = {
  Component: Translate,
  handlesCssProperties: ["translate"],
};
